module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-stronglist.json
// module id = 336
// module chunks = 44111250808295